import React, { useEffect, useState } from "react";
import { ReactComponent as Adharcard } from "../../../Assets/img/Kyc/svg/AadharCard.svg";
import { ReactComponent as Pancard } from "../../../Assets/img/Kyc/svg/PANcard.svg";
// import { ReactComponent as DL } from "../../../Assets/img/Kyc/svg/driver-license-identification-id-card-template 1.png";
import driverLicense from "../../../Assets/img/Kyc/svg/driver-license-identification-id-card-template 1.png";
import { Box, Button, Dialog, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Flag from "../../../Assets/img/Kyc/Flag1.jpg";
import Lion from "../../../Assets/img/Kyc/Lion.png";
import digi from "../../../Assets/img/Kyc/digi2.jpg";
import income_tax from "../../../Assets/img/Kyc/income_tax.png";
import QR from '../../../Assets/QRcode.png';
import Dummy_Mob_qr from '../../../Assets/img/Dummy_Mob_qr.png';
import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';
import { motion } from "framer-motion";
import QRCode from "qrcode.react";
import adhaarMask from "../../../Assets/img/Kyc/adhaarMask.png";
import panMask from "../../../Assets/img/Kyc/PanCardMask.png"
import { useDispatch } from "react-redux";
import { getKycOcrApiReducer } from "../../../Redux/Reducers/KycReducer";
const DL = () => {
  return <img src={driverLicense} alt="Driver License" />;
};

const ID = () => {
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
    // "ngrok-skip-browser-warning": "69420"
  };

  const dispatch = useDispatch();
  const [docInfo, setDocInfo] = useState(null);
  const [showAadhar, setShowAadhar] = useState([]);
  const [showPan, setShowPan] = useState([]);
  const [showDl, setShowDl] = useState([]);
  const [clicked, setClicked] = useState(false);
  const [showErrorMsg, setShowErrorMessage] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]); // To track selected images
  const [showQr, setShowQr] = useState(false); // Flip stateS
  const [digiInfo, setDigiInfo] = useState([])
  const [isCardVisible, setIsCardVisible] = useState(false);
  const [isPanCardVisible, setIsPanCardVisible] = useState(false);
  const [showQrModal, setShowQrModal] = useState(false);
  const [qrDocType, setQrDocType] = useState("aadhar");
  // const toggleQr = () => setShowQr((prev) => !prev);
  const handlePanImageClick = () => {
    setIsPanCardVisible((prev) => !prev);
  };

  const handleImageClick = () => {
    setIsCardVisible((prev) => !prev);
  };

  console.log("digiInfo", digiInfo);

  useEffect(() => {
    const handleDocInfo = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/ocr/images`,
          { headers }
        );
        const data = response.data?.data || [];

        // console.log("data", data);
        if (data) {
          if (docInfo === null && response.data.statusCode === 200) {
            console.log("data", data);
            setDocInfo(data);
          } else if (response.data.statusCode === 400) {
            console.log("INside first else block");
            setShowErrorMessage(true);

          } else {
            setShowErrorMessage(true);
          }
        } else {
          setShowErrorMessage(true);
        }

      } catch (err) {
        console.error("Document Error", err);
      }
    };
    handleDocInfo();

    const handlDigiInfo = async () => {

      try {
        const response = await dispatch(getKycOcrApiReducer());
        const data = response?.payload?.data || [];
  
        if (docInfo === null || response.payload.statusCode === 200) {
          if (response?.payload?.message === "No documents found") {
            setShowErrorMessage(true);

          }
          if (data?.aadharData === null && data?.dlData === null && data?.panData === null && data?.aadharData === undefined && data?.dlData === undefined && data?.panData === undefined && data?.aadharData === "Not verified Yet" && data?.dlData === "Not verified Yet" && data?.panData === "Not verified Yet") {

            setShowErrorMessage(true);

          } else {

            setDigiInfo(data);

          }
        } else if (response?.payload?.statusCode === 400) {
          setShowErrorMessage(true);
        } else {
          setShowErrorMessage(true);
        }
      } catch (err) {
        console.error("Document Error", err);
      }
    };
    handlDigiInfo();
  }, []);

  const handleDocument = (data) => {
    setClicked(true);
    navigate(location.pathname);

    if (data === "aadharInfo") {
      const aadhaarDocs = docInfo.filter(
        (doc) =>
          doc.document_type === "Aadhaar_Front" ||
          doc.document_type === "Aadhaar_Back"
      );
      setShowAadhar(aadhaarDocs);
    } else if (data === "pancardInfo") {
      const panDocs = docInfo.filter(
        (doc) => doc.document_type === "PAN_Front"
      );
      setShowPan(panDocs);
    } else if (data === "dlInfo") {
      const dlDocs = docInfo.filter(
        (doc) =>
          doc.document_type === "DL_Front" || doc.document_type === "DL_Back"
      );
      setShowDl(dlDocs);
    }
  };

  const handleOpen = (images) => {
    setSelectedImages(images); // Set the selected images
    setOpen(true); // Open the modal
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImages([]); // Reset the selected images
  };

  const handletopClose = () => {
    navigate("/home");
  };

  const toggleQr = () => {
    setShowQr((prev) => !prev); // Toggle flip state
  };

  const handleQrClick = (docType = "aadhar") => {
    setQrDocType(docType);
    setShowQrModal(true);
  };

  const handleQrModalClose = () => {
    setShowQrModal(false);
  }

  return (
    <div className="home-page-container">
      {showErrorMsg ? (
        <Dialog open={showErrorMsg} onClose={handletopClose}>
          <Box
            sx={{
              width: "600px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "white",
              borderRadius: "8px",
              height: "120px",
              padding: "20px",
            }}
          >
            <CloseIcon onClick={handletopClose} className="close-btn-id" />
            <Typography variant="h6">No Documents found Please  Verify your Identity</Typography>
            <Typography sx={{ mt: 2, textAlign: "center" }}>
              to verify identity <a href="/countrySelecting" style={{ color: "blue" }}>Clickhere</a>
            </Typography>
          </Box>
        </Dialog>
      ) : clicked ? (
        <div className="p-3 d-flex" style={{ height: "auto" }}>
          {showAadhar.length > 0 && (
            <div
              className="bg-white m-1 rounded-2 p-5 text-center"
              style={{
                width: "1500px", // Retain original dimensions
                maxWidth: "100%", // Ensures responsiveness
                overflow: "hidden", // Prevents content overflow
              }}
            >
              <h3 className="fw-semibold">Verified Aadhaar</h3>
              <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                <button
                  // onClick={() => handleOpen(showAadhar.map((doc) => doc.blob_url))}
                  // style={{
                  //   display: "flex",
                  //   flexDirection: "row",
                  //   gap: "20px",
                  //   border: "1px gray",
                  //   margin: "auto",
                  //   marginBottom: "20px",
                  //   boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                  // }}
                  className="customPrivateIdHoverButton"
                >
                  {/* {showAadhar.map((doc) => (
                    <img
                      key={doc.id}
                      src={doc.blob_url}
                      alt={doc.document_type}
                      style={{ width: "200px", height: "140px", border: "1px solid #ccc" }}
                    />
                  ))} */}

                  {[
                    ...new Map(
                      showAadhar.map((doc) => [doc.document_type, doc]) // Keeps only one per document_type
                    ).values()
                  ].map((doc) => (
                    <img
                      key={doc.id}
                      src={doc.blob_url}
                      alt={doc.document_type}
                      style={{
                        width: "200px",
                        height: "140px",
                        border: "1px solid #ccc",
                        marginRight: "10px"
                      }}
                    />
                  ))}
                </button>
              </div>

              <div
                onClick={handleImageClick}
                style={{
                  width: "400px",
                  height: "590px",
                  margin: "auto",
                  perspective: "1000px",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    position: "relative",
                    transformStyle: "preserve-3d",
                    transition: "transform 0.6s",
                    transform: isCardVisible ? "rotateY(180deg)" : "rotateY(0deg)",
                  }}
                >
                  {/* Front Side (Image) */}
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      backfaceVisibility: "hidden",
                      position: "absolute",
                      top: 0,
                      left: 0,
                    }}
                  >
                    <img
                      src={adhaarMask}
                      alt="Aadhaar Mask"
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "2px solid gray",
                        borderRadius: "15px",
                      }}
                    />
                  </div>

                  {/* Back Side (Card Details) */}
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      backfaceVisibility: "hidden",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      transform: "rotateY(180deg)",
                      backgroundColor: "white",
                      border: "2px solid gray",
                      borderRadius: "15px",
                      padding: "10px",
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        flexWrap: "wrap",
                        rowGap: "10px",
                      }}
                    >
                      <img
                        style={{ width: "15%", minWidth: "50px", objectFit: "contain" }}
                        src={Lion}
                        alt="Lion Logo"
                      />
                      <img
                        style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
                        src={Flag}
                        alt="Flag Logo"
                      />
                      <img
                        style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
                        src="https://www.pngkey.com/png/full/224-2240746_aadhaar-logo-aadhar-card-logo-png.png"
                        alt="Aadhaar Logo"
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        padding: "10px",
                        flexDirection: "row",
                        gap: "10px",
                        alignItems: "center",
                        flexWrap: "wrap",
                        width: "100%",
                      }}
                    >
                      <img
                        style={{
                          width: "30%",
                          minWidth: "120px",
                        }}
                        src={
                          digiInfo?.aadharData?.photo
                            ? `data:image/png;base64,${digiInfo?.aadharData?.photo}`
                            : "https://icon-library.com/images/man-png-icon/man-png-icon-14.jpg"
                        }
                        alt="Profile"
                      />
                      <div
                        style={{
                          textAlign: "left",
                          flex: "1",
                          display: "flex",
                          flexDirection: "column",
                          minWidth: "200px",
                          padding: "10px",
                        }}
                      >
                        <h6>Name: {digiInfo?.aadharData?.name || "N/A"}</h6>
                        <h6>Aadhaar: {digiInfo?.aadharData?.masked_id || "N/A"}</h6>
                        <h6>DOB: {digiInfo?.aadharData?.dob || "N/A"}</h6>
                        <h6>Gender: {digiInfo?.aadharData?.gender || "N/A"}</h6>
                      </div>
                    </div>
                    <hr />
                    <div style={{ textAlign: "left", padding: "10px" }}>
                      <h6>
                        Address: {digiInfo?.aadharData?.house} {digiInfo?.aadharData?.street}{" "}
                        {digiInfo?.aadharData?.locality} {digiInfo?.aadharData?.city}{" "}
                        {digiInfo?.aadharData?.state}
                      </h6>
                    </div>
                    <hr />
                    <div
                      style={{
                        textAlign: "left",
                        padding: "20px",
                        display: "flex",
                        justifyContent: "space-evenly",
                        flexWrap: "wrap",
                        rowGap: "15px",
                      }}
                    >
                      <img
                        style={{
                          width: "55%",
                          minWidth: "100px",
                          height: "auto",
                          objectFit: "contain",
                        }}
                        src={digi}
                        alt="Digi Info"
                      />
                      {/* <img
                        onClick={handleQrClick}
                        style={{
                          width: "25%",
                          minWidth: "100px",
                          height: "auto",
                          objectFit: "contain",
                        }}
                        src="https://api.qrserver.com/v1/create-qr-code/?size=100x100&data=https://neoin.com"
                        alt="QR Code"
                      /> */}
                      <Box
                        onClick={()=>handleQrClick("aadhar")}
                        sx={{
                          cursor: "pointer",
                          display: "inline-block",
                          '&:hover': { opacity: 0.8, transform: 'scale(1.05)' },
                          transition: "all 0.2s"
                        }}
                      >
                        <QRCode
                          value={`${window.location.origin}/public-docview?token=${objectId}&docType=aadhar`}
                          size={150}
                        />
                      </Box>
                    </div>
                    <hr style={{ color: "red", width: "80%", margin: "auto", padding: "5px" }} />
                    <h6>
                      <span style={{ color: "red" }}>आधार</span> - आम आदमी का अधिकार
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showPan?.length > 0 && (
            <div className="bg-white m-1 rounded-2 p-5 text-center" style={{ width: "1500px", height: "120vh" }}>
              <h3 className="fw-semibold">Verified PAN Card</h3>
              <div style={{ display: "flex", gap: "10px", margin: "auto", justifyContent: "center", marginBottom: "10px", }}>
                <Button
                  // onClick={() => handleOpen([doc.blob_url])}
                  onClick={() => handleOpen(showPan.map(doc => doc.blob_url))}
                  className="customPrivateIdHoverButton"
                // style={{ display: "flex", flexDirection: "row", gap: "10px", border: "1px  gray", margin: "auto", marginBottom: "20px" }}
                >
                  {/* {showPan?.map((doc) => (
                    <img
                      key={doc.id}
                      src={doc.blob_url}
                      alt={doc.document_type}
                      style={{ width: "350px", height: "250px", border: "1px gray", padding: "3%", borderRadius: "15px", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)" }}

                    />
                  ))} */}


                  {[
                    ...new Map(
                      showPan?.map((doc) => [doc.document_type, doc]) // Keeps only one per document_type
                    ).values()
                  ].map((doc) => (
                    <img
                      key={doc.id}
                      src={doc.blob_url}
                      alt={doc.document_type}
                      style={{
                        width: "350px",
                        height: "250px",
                        border: "1px solid #ccc",
                        marginRight: "10px"
                      }}
                    />
                  ))}
                </Button>
              </div>

              {showPan.length > 0 && (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      gap: "10px",
                      flexWrap: "wrap",
                      margin: "20px auto", // Center content and adjust margin
                      maxWidth: "90%", // Prevents it from occupying the full width
                      width: "600px", // Default width for larger screens
                      perspective: "1000px", // Required for 3D flip
                    }}
                  >
                    <div
                      style={{
                        flex: "1 1 auto",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transformStyle: "preserve-3d",
                        transition: "transform 0.6s",
                        transform: isPanCardVisible ? "rotateY(180deg)" : "rotateY(0deg)",
                        cursor: "pointer",
                        position: "relative",
                        maxWidth: "60%",
                        padding: "10px",
                      }}
                      onClick={handlePanImageClick}
                    >
                      {/* Front Side - Pan Mask */}
                      <div
                        style={{
                          position: "absolute",
                          backfaceVisibility: "hidden",
                          width: "100%",
                          marginTop: "60vh"
                        }}
                      >
                        {/* <h6>Tap to Scan the QR</h6> */}
                        <img
                          src={panMask}
                          alt="Pan Mask"
                          style={{
                            border: "2px solid gray",
                            borderRadius: "15px",
                            width: "90%",
                            height: "65vh",
                          }}
                        />
                      </div>

                      {/* Back Side - PAN Card */}
                      <div
                        style={{
                          position: "absolute",
                          backfaceVisibility: "hidden",
                          transform: "rotateY(180deg)",
                          width: "100%",
                          marginTop: "65vh"

                        }}
                      >
                        <motion.div
                          initial={{ x: -300, opacity: 0 }}
                          animate={isPanCardVisible ? { x: 0, opacity: 1 } : { x: -300, opacity: 0 }}
                          transition={{ duration: 0.5 }}
                          style={{
                            border: "2px solid gray",
                            borderRadius: "15px",
                            padding: "20px",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                            backgroundColor: "white",
                          }}
                        >
                          {/* Header */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-evenly",
                              flexWrap: "wrap",
                              rowGap: "10px",
                            }}
                          >
                            <img
                              style={{ width: "15%", minWidth: "50px", objectFit: "contain" }}
                              src={Lion}
                              alt="Lion Logo"
                            />
                            <img
                              style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
                              src={Flag}
                              alt="Flag Logo"
                            />
                            <img
                              style={{ width: "20%", minWidth: "50px", objectFit: "contain" }}
                              src={income_tax}
                              alt="Income Tax Logo"
                            />
                          </div>
                          <hr style={{ color: "blue" }} />

                          {/* Details Section */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "20px",
                              alignItems: "center",
                              flexWrap: "wrap",
                              marginTop: "15px",
                              justifyContent: "center"
                            }}
                          >
                            <div style={{ textAlign: "left", flex: "1 1 auto", alignItems: "flex-start", }}>
                              <p style={{ margin: "5px 0" }} >
                                <strong style={{ fontSize: "16px" }}>PAN Card</strong>
                              </p>
                              <p style={{ margin: "5px 0" }}>
                                Name: {digiInfo?.panData?.name || "N/A"}
                              </p>
                              <p style={{ margin: "5px 0" }}>
                                PAN Number:
                                <span style={{ marginLeft: "5px" }}>
                                  {digiInfo?.panData?.pan_number || "N/A"}
                                </span>
                              </p>
                              <p style={{ margin: "5px 0" }}>
                                DOB: {digiInfo?.panData?.dob || "N/A"}
                              </p>
                              <p style={{ margin: "5px 0" }}>
                                Gender: {digiInfo?.panData?.gender || "N/A"}
                              </p>

                            </div>

                          </div>
                          <hr />
                          <p style={{ textAlign: "center", margin: "5px 0" }}>
                            Digilocker | NEOIN
                          </p>

                          <hr />

                          {/* Additional Details */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: "5px",
                              marginTop: "10px",
                              marginBottom: "10px",
                              padding: "5px",
                            }}
                          >
                            <img
                              style={{
                                width: "50%",
                                height: "auto",
                                objectFit: "contain",
                              }}
                              src={digi}
                              alt="Digilocker Logo"
                            />
                            {/* <img
                              style={{
                                width: "35%",
                                minWidth: "100px",
                                height: "auto",
                                objectFit: "contain",
                              }}
                              // src={"https://www.freepik.com/vectors/dummy-qr-code"}
                              src={Dummy_Mob_qr}
                              alt="QR Code"
                            /> */}
                            <Box
                              onClick={() => handleQrClick("pan")}
                              sx={{
                                cursor: "pointer",
                                display: "inline-block",
                                '&:hover': { opacity: 0.8, transform: 'scale(1.05)' },
                                transition: "all 0.2s"
                              }}
                            >
                              <QRCode
                                value={`${window.location.origin}/public-docview?token=${objectId}&docType=pan`}
                                size={100}
                              />
                            </Box>
                          </div>
                          <hr style={{ color: "blue", padding: "5px" }} />

                          <div style={{ textAlign: "center" }}>
                            <h6>
                              स्थायी खाता संख्या कार्ड
                            </h6>
                          </div>

                        </motion.div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

          )}


          {showDl.length > 0 && (
            <div className="bg-white m-1 rounded-2 p-5 text-center" style={{ width: "100%" }}>
              <h3 className="fw-semibold">Verified Driving License</h3>
              <div style={{ display: "flex", gap: "10px", justifyContent: "center", margin: "auto", marginBottom: "10px" }}>
                <Button
                  onClick={() => handleOpen(showDl.map(doc => doc.blob_url))}
                  className="customPrivateIdHoverButton"
                // style={{ display: "flex", flexDirection: "row", gap: "10px", border: "1px  gray", margin: "auto", marginBottom: "20px" }}
                >
                  {/* {showDl.map((doc) => (
                    <img
                      key={doc.id}
                      src={doc.blob_url}
                      alt={doc.document_type}
                      style={{ width: "200px", height: "140px", border: "1px solid #ccc", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)" }}
                    />
                  ))} */}

                  {[
                    ...new Map(
                      showDl.map((doc) => [doc.document_type, doc]) // Keeps only one per document_type
                    ).values()
                  ].map((doc) => (
                    <img
                      key={doc.id}
                      src={doc.blob_url}
                      alt={doc.document_type}
                      style={{
                        width: "200px",
                        height: "140px",
                        border: "1px solid #ccc",
                        marginRight: "10px"
                      }}
                    />
                  ))}
                </Button>
              </div>
              {showDl.length > 0 && (
                <div> {<div style={{
                  border: "2px solid gray",
                  borderRadius: "15px",
                  padding: "10px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                  maxWidth: "30vw",
                  margin: "auto"
                }}>

                  <div style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center", // This centers items vertically
                    flexWrap: "wrap",
                    rowGap: "10px",
                  }}>
                    <img style={{ width: "15%", minWidth: "80px", objectFit: "contain" }} src={Lion} alt="logo" />
                    <h6>Driving License</h6>
                  </div>

                  <hr />

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "5px",
                      alignItems: "flex-start",
                      flexWrap: "wrap",
                      marginTop: "15px",
                    }}
                  >
                    {/* <div style={{ display: "flex", flexDirection: "row", textAlign: "left" }}> */}
                    <div style={{ textAlign: "left", minWidth: "120px", flex: "1 1 auto" }}>
                      {/* <div style={{ fontSize: "6px", padding: "10px", minWidth: "150px" }}> */}
                      <h6>Name: {digiInfo?.dlData?.name}</h6>
                      <h6>License No:{digiInfo?.dlData?.dl_number}</h6>
                      <h6>Date of issue: {digiInfo?.dlData?.doi}</h6>
                      <h6>DOB: {digiInfo?.dlData?.dob}</h6>
                      <h6>S/W/D: {digiInfo?.dlData?.swd || "N/A"}</h6>
                      <h6>Blood Group: {digiInfo?.dlData?.bg || "Unknown"}</h6>
                      <h6>Date of Expiry: {digiInfo?.dlData?.expiry_date}</h6>
                      <h6>Present Address: {digiInfo?.dlData?.current_address}</h6>

                      {/* </div> */}
                      {/* <div
                        style={{
                          textAlign: "left",
                          flex: "1",
                          display: "flex",
                          flexDirection: "column",
                          minWidth: "260px",
                          padding: "10px",
                          fontSize: "6px"
                        }}
                      >
                        <h6></h6>
                        <h6>: </h6>
                        <h6></h6>
                        <h6></h6>
                        <h6></h6>
                        <h6></h6>
                        <h6></h6>
                        <h6></h6>
                        <h6></h6>
                      </div> */}
                    </div>
                  </div>
                  <hr />
                  <div style={{
                    textAlign: "left",
                    padding: "20px",
                    display: "flex",
                    justifyContent: "space-evenly",
                    flexWrap: "wrap",
                    rowGap: "15px"
                  }}>
                    {/* <img
                      style={{
                        width: "30%",
                        minWidth: "100px",
                        height: "auto",
                        objectFit: "contain"
                      }}
                      src={"http://www.pngmart.com/files/10/Qr-Code-Transparent-PNG.png"}
                      alt="logo"
                    /> */}
                    {/* <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      > */}
                    <img
                      style={{
                        width: "40%",
                        minWidth: "100px",
                        height: "auto",
                        objectFit: "contain"
                      }}
                      src={digi}
                      alt=" digilocker logo"
                    />
                    {/* </div> */}
                    <img
                      style={{
                        width: "30%",
                        minWidth: "100px",
                        height: "auto",
                        objectFit: "contain"
                      }}
                      src={digiInfo?.dlData?.photo ? `data:image/png;base64,${digiInfo?.dlData?.photo}` : "https://icon-library.com/images/man-png-icon/man-png-icon-14.jpg"}
                      alt="user Image"
                    />

                  </div>

                </div>
                  || "No DL number available"}</div>
              )}
            </div>
          )}

          {/* <div style={{ maxHeight: "30vh" }}>
                    </div> */}
        </div>
      ) : (
        <div className="d-flex" style={{ height: "620px" }}>
          <div
            className="bg-white m-4 rounded-2 p-5 d-flex"
            style={{ width: "1500px" }}
          >
            {/*  */}
            {docInfo &&
              [
                {
                  label: "Aadhaar",
                  icon: Adharcard,
                  data: "aadharInfo",
                  present:
                    digiInfo?.aadharData !== undefined && digiInfo?.aadharData !== null && digiInfo?.aadharData !== "Not verified Yet" &&
                    docInfo.filter(
                      (doc) => doc.document_type === "Aadhaar_Front"
                    ).length > 0 &&
                    docInfo.filter(
                      (doc) => doc.document_type === "Aadhaar_Back"
                    ).length > 0,
                },
                {
                  label: "Pancard",
                  icon: Pancard,
                  data: "pancardInfo",
                  present:
                    digiInfo?.panData !== "Not verified Yet" && digiInfo?.panData !== undefined && digiInfo?.panData !== null &&
                    docInfo.filter((doc) => doc.document_type === "PAN_Front")?.length > 0,
                },
                {
                  label: "DL",
                  icon: DL,
                  data: "dlInfo",
                  present:
                    digiInfo?.dlData !== null && digiInfo?.dlData !== undefined && digiInfo?.dlData !== "Not verified Yet" &&
                    docInfo.filter((doc) => doc.document_type === "DL_Front")
                      .length > 0 &&
                    docInfo.filter((doc) => doc.document_type === "DL_Back")
                      .length > 0,
                },
              ]
                .filter((doc) => {
                  if (docInfo?.document_type == "Aadhaar_Front") return doc.data === "aadharInfo";
                  if (docInfo?.document_type == "PAN_Front") return doc.data === "pancardInfo";
                  if (docInfo?.document_type == "Dl") return doc.data === "dlInfo";
                  return true;
                })
                .map((doc) => (
                  <div
                    className="m-2"
                    style={{
                      width: "120px",
                      display: doc.present ? "block" : "none",
                    }}
                    key={doc.label}
                  >
                    <Button
                      className="private-verify-icons"
                      onClick={() => handleDocument(doc.data)}
                    >
                      <doc.icon style={{ width: "40px", height: "40px" }} />
                    </Button>
                    <p className="d-flex justify-content-center align-items-center text-center">
                      {doc.label}
                    </p>
                  </div>
                ))}
          </div>
        </div>
      )}

      {/* Modal to show selected images */}
      {/* <Dialog open={open} onClose={handleClose}>
        {/* <CloseIcon onClick={handleClose} className="close-btn-id" /> */}
      {/* <motion.div
          style={{
            perspective: "1000px", // Adds 3D perspective
            width: "500px",
            height: "300px",
            position: "relative",
          }}
          onClick={toggleQr} // Trigger the flip on click
        >
          <motion.div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              transformStyle: "preserve-3d", // For 3D effect
              transform: showQr ? "rotateY(180deg)" : "rotateY(0deg)", // Flipping state
              transition: "transform 0.8s ease-in-out", // Smooth transition for flip
            }}
          >
            {/* Front Side */}
      {/* <Box
              sx={{
                position: "absolute",
                backfaceVisibility: "hidden", // Hide when flipped
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column", // Stack the heading and images vertically
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#fff",
                borderRadius: "8px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                padding: "20px", // Padding to create some space inside the container
              }}
            >  */}
      {/* <h4 style={{ marginBottom: "20px", textAlign: "center" }}>
                Click here to Scan the QR Code
              </h4> */}
      {/* <div style={{ display: "flex", gap: "10px" }}> */}
      {/* {selectedImages.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Document ${index + 1}`}
                    style={{
                      maxWidth: "200px",
                      maxHeight: "200px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                    }}
                  />
                ))} */}

      {/* {[
                  ...new Map(
                    selectedImages.map((img, index) => [img, img]) // Keeps only one per unique image URL
                  ).values()
                ].map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Document ${index + 1}`}
                    style={{
                      maxWidth: "200px",
                      maxHeight: "200px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      marginRight: "10px"
                    }}
                  />
                ))} */}

      {/* </div>
            // </Box>

            {/* Back Side */}
      {/* <Box
        sx={{
          position: "absolute",
          backfaceVisibility: "hidden", // Hide when not facing front
          // transform: "rotateY(180deg)", // Align back side
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          <h4>Scan QR</h4>
          <QRCode value="https://example.com" size={150} />
        </Typography>
      </Box> */}
      {/* </motion.div> */}
      {/* </motion.div > */}
      {/* </Dialog >   */}
      <Dialog open={showQrModal} onClose={handleQrModalClose} maxWidth="sm" fullWidth>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "30px",
            backgroundColor: "white",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%", mb: 2 }}>
            <CloseIcon
              onClick={handleQrModalClose}
              sx={{ cursor: "pointer", fontSize: "28px" }}
            />
          </Box>
          <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
            Scan QR Code
          </Typography>
          <QRCode
            value={`${window.location.origin}/public-docview?token=${objectId}&docType=${qrDocType}`}
            size={400}
          />
        </Box>
      </Dialog>
    </div >
  );
};

export default ID;
